import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';

class Dashboard extends Component {
  render() {
    return (
      <Layout>
        <div className="container">
          <h1>Vítejte v administraci!</h1>
          <p>Upravit můžete tyto položky</p>
          <ul>
            <li>
              <Link tag={Link} to="/homepage">
                Homepage
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/sluzby">
                Služby
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/informace">
                Užitečné informace
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/clanky">
                Články
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/kontakt">
                Kontakt
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/cenik">
                Ceník
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/oklinice">
                O klinice
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/zamestnanci">
                Zaměstnanci
              </Link>
            </li>
            <li>
              <Link tag={Link} to="/reference">
                Reference
              </Link>
            </li>
          </ul>
          <p>
            V případě problémů s administrací nahašte problém na{' '}
            <a href="mailto:admin@ikiguys.com">admin@ikiguys.com</a>
          </p>
        </div>
      </Layout>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Dashboard.js